import { Component, OnInit, Input, trigger, style, animate, transition, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { ProgramService } from './../services/program.service';

@Component({
  selector: 'app-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.less'],
  animations: [
    trigger('toggle', [
      transition('void => *', [
        style({ height: '0' }),
        animate(250)
      ]),
      transition('* => void', [
        animate(250, style({ height: '*' }))
      ])
    ])
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleComponent),
      multi: true,
    }
  ]
})

export class ToggleComponent implements OnInit , ControlValueAccessor {
  @Input() isActive: boolean;
  @Input() noInternalState: boolean;
  @Input() toggleView: boolean;
  @Input() masterLabel: string;
  @Input() description: string;
  @Input() inverted = false;
  @Input() triState = false;
  @Input() disable = false;
  @Input() confirmOn: string;
  @Input() confirmOff: string;
  @Output() toggled: EventEmitter<boolean> = new EventEmitter<boolean>();

  private propagateChange: (_: any) => { };
  private propagateTouch: () => { };

  constructor(programService: ProgramService) { }

  ngOnInit() {
    if (this.inverted && this.triState) throw 'Slider cannot be tristate and inverted';
  }

  public toggleChange() {
    // Toggle internal state
    if (this.disable) {
      return;
    }

    let newState: boolean;
    if (this.isActive === null) newState = true
    else if (this.isActive === true) newState = false
    else if (this.isActive === false) newState = true
    else throw new Error('Toggle state invalid')

    // Display optional confirmations
    if (this.confirmOn && newState) {
      if (!confirm(this.confirmOn)) {
        return;
      }
    }
    if (this.confirmOff && !newState) {
      if (!confirm(this.confirmOff)) {
        return;
      }
    }

    if (!this.noInternalState) {
      this.isActive = newState;
    }

    // Select output value
    let output;
    if (this.inverted) {
      if (newState === null) {
        output = null;
      } else {
        output = !newState;
      }
    } else {
      output = newState;
    }
    // Output values
    if (this.propagateChange) {
      this.propagateChange(output);
    }
    if (this.toggled) {
      this.toggled.emit(output);
    }
    if (this.propagateTouch) {
      this.propagateTouch();
    }
  }

 public preventToggle(e) {
    e.stopPropagation();
  }

  public writeValue(active: boolean) {
    if (this.inverted) active = !active;
    this.isActive = active;
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched(fn: any) {
    this.propagateTouch = fn;
  }

  public setDisabledState(isDisabled: boolean) {
    this.disable = isDisabled;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/toggle/toggle.component.ts